import React from 'react'

export default () => (
  <svg viewBox="0 0 37 15">
    <path fillRule="evenodd" clipRule="evenodd" d="m30.211.5-.72.742 5.452 5.728H0v1.06h34.943l-5.452 5.728.72.742L37 7.5l-6.789-7Z"/>
  </svg>
)
